import { CaseSchedulesAlertButton } from '@/pages/ui/case-scheduled-alert-button/case-scheduled-alert-button'

import { type ResCaseAlertItem } from '@/lib/queries/business/v1/alert/types'

import { UpdateAlertDialog } from '../../dialogs/update-alert-dialog/update-alert-dialog'
import { useCaseAlertItem } from './use-case-alert-item'

export interface CaseAlertItemProps {
  item: ResCaseAlertItem
  order: number
}

export const CaseAlertItem = ({ item, order }: CaseAlertItemProps) => {
  const { isCaseAlertUpdateDialogOpen, openCaseAlertUpdateDialog, closeCaseAlertUpdateDialog } = useCaseAlertItem()

  return (
    <>
      <CaseSchedulesAlertButton
        order={order}
        alertType={item.alertType}
        deadline={item.deadline}
        notificationTime={item.notificationTime}
        onClick={openCaseAlertUpdateDialog}
      />
      {isCaseAlertUpdateDialogOpen && (
        <UpdateAlertDialog open={isCaseAlertUpdateDialogOpen} alertData={item} onClose={closeCaseAlertUpdateDialog} />
      )}
    </>
  )
}
